import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ConfirmationModalComponent } from "../confirmation-modal/confirmation-modal.component";

/**
 * Confirms leaving the app shell before an external link is handed off to the
 * device's system browser. Opened via ExternalLinkService when running inside
 * the mobile WebView.
 */
@Component({
  selector: "app-dialog-leave-app",
  templateUrl: "./dialog-leave-app.component.html",
  styleUrls: ["./dialog-leave-app.component.scss"],
  standalone: true,
  imports: [CommonModule, ConfirmationModalComponent],
})
export class DialogLeaveAppComponent {
  constructor(public dialogRef: MatDialogRef<DialogLeaveAppComponent, boolean>) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
